import script from "./SguWizard.vue?vue&type=script&setup=true&lang=js"
export * from "./SguWizard.vue?vue&type=script&setup=true&lang=js"

import "./SguWizard.vue?vue&type=style&index=0&id=43892af4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43892af4"]])

export default __exports__